<template>
  <button
    class="app-icon-btn"
    :class="{ 'app-icon-btn--danger': danger }"
    type="button"
    :disabled="disabled"
    :title="title"
    :aria-label="title"
    v-bind="$attrs"
    v-on="$listeners">
    <AppIcon :icon="icon" :size="size" :color="iconColor" />
  </button>
</template>

<script>
import AppIcon from './AppIcon.vue'

export default {
  name: 'AppIconButton',
  components: {
    AppIcon
  },
  inheritAttrs: false,
  props: {
    icon: {
      type: String,
      required: true
    },
    size: {
      type: [String, Number],
      default: 24
    },
    color: {
      type: String,
      default: '#656565'
    },
    title: {
      type: String,
      default: ''
    },
    danger: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    iconColor () {
      if (this.danger && this.color === '#656565') {
        return 'var(--app-danger, #f46a6a)'
      }
      return this.color
    }
  }
}
</script>

<style scoped>
.app-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.25rem;
  margin: 0;
  border: none;
  background: transparent;
  border-radius: 4px;
  color: inherit;
  cursor: pointer;
  line-height: 0;
  outline: none;
  -webkit-tap-highlight-color: transparent;
  transition: color 0.15s ease, background-color 0.15s ease, filter 0.15s ease;
}

.app-icon-btn:focus {
  outline: none;
  box-shadow: none;
}

.app-icon-btn:hover:not(:disabled) {
  filter: brightness(0.85);
}

.app-icon-btn--danger:hover:not(:disabled) {
  color: var(--app-danger, #f46a6a);
}

.app-icon-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>
